import SizePicker from './SizePicker.jsx';

export default SizePicker;


// WEBPACK FOOTER //
// ./src/components/SizePicker/index.jsx